export default server => ({
    async all() {
        let {data} = await server.get('regions');
        return data;
    },
});